import {useQuery} from '@tanstack/react-query';
import {useChekinSDK} from 'context/ChekinSDK';
import {QUERY_CACHE_KEYS} from '@chekin/core';
import {API} from '@chekin/api';

type GuestProps = {
  id?: string;
};

function useGuest({id}: GuestProps) {
  const {isSuccessSDK} = useChekinSDK();

  const {
    data,
    isLoading: isLoadingInternal,
    isError,
  } = useQuery({
    queryKey: [QUERY_CACHE_KEYS.guest, id],
    queryFn: () => API.guest.getOne(id || ''),
    refetchOnWindowFocus: false,
    refetchOnMount: true,
    enabled: isSuccessSDK && Boolean(id),
  });

  const isGuestLoaded = Boolean(data?.id) && !isLoadingInternal;
  const isLoading = Boolean(id) && isLoadingInternal;

  return {
    guest: data,
    isLoading,
    isError,
    isGuestLoaded,
  };
}

export {useGuest};
